{
  "EN": {
    "optional": "(Optional)",
    "cancel": "Cancel",
    "apply": "Apply",
    "invalidDOB": "Please enter a valid Date of Birth.",
    "futureDOB": "Please enter a valid Date of Birth. The date must be in the past.",
    "next": "Next",
    "genderMaritalNote": "*We collect information on gender and marital status to better understand your background and support your journey with IDP.",
    "learnMore": "Learn more",
    "learnMoreTitle": "Why do we collect information about you?",
    "learnMoreIntro": "This information helps us to:",
    "learnMorePoint1Title": "Tailor our guidance and support",
    "learnMorePoint1Desc": "Including course recommendations, student services, and accommodation options.",
    "learnMorePoint2Title": "Assist with visa and travel requirements",
    "learnMorePoint2Desc": "As some study destinations have specific immigration rules for married students or accompanying spouses. Providing your marital status enables us to offer accurate advice and ensure smoother processing for your chosen destination.",
    "learnMorePoint3Title": "Contribute to inclusive planning and reporting",
    "learnMorePoint3Desc": "Helping us improve service delivery and meet diversity, equity, and regulatory expectations. Providing gender and marital status information is optional, and you may choose \"Prefer not to say\" if preferred. Your personal data will be handled securely and in accordance with applicable data protection laws and our institutional privacy policies.",
    "ok": "OK"
  },
  "ID_IND": {
    "optional": "(Opsional)",
    "cancel": "Batal",
    "apply": "Terapkan",
    "invalidDOB": "Silakan masukkan tanggal lahir yang valid",
    "futureDOB": "Tanggal harus di masa lalu",
    "next": "Berikutnya",
    "genderMaritalNote": "Kami mengumpulkan informasi tentang jenis kelamin dan status pernikahan untuk lebih memahami latar belakang Anda dan mendukung perjalanan Anda bersama IDP.",
    "learnMore": "Pelajari lebih lanjut",
    "learnMoreTitle": "Mengapa kami mengumpulkan informasi tentang Anda?",
    "learnMoreIntro": "Informasi ini membantu kami untuk:",
    "learnMorePoint1Title": "Menyesuaikan panduan dan dukungan kami",
    "learnMorePoint1Desc": "Termasuk rekomendasi kursus, layanan mahasiswa, dan pilihan akomodasi.",
    "learnMorePoint2Title": "Membantu persyaratan visa dan perjalanan",
    "learnMorePoint2Desc": "Beberapa tujuan studi memiliki aturan imigrasi khusus untuk mahasiswa yang sudah menikah atau pasangan yang mendampingi. Memberikan status pernikahan Anda memungkinkan kami memberikan saran yang akurat dan memastikan proses yang lebih lancar untuk tujuan pilihan Anda.",
    "learnMorePoint3Title": "Berkontribusi pada perencanaan dan pelaporan yang inklusif",
    "learnMorePoint3Desc": "Membantu kami meningkatkan layanan dan memenuhi ekspektasi keberagaman, kesetaraan, dan regulasi. Memberikan informasi jenis kelamin dan status pernikahan bersifat opsional, dan Anda dapat memilih \"Memilih untuk tidak menyebutkan\" jika diinginkan. Data pribadi Anda akan ditangani dengan aman sesuai dengan undang-undang perlindungan data yang berlaku dan kebijakan privasi institusi kami.",
    "ok": "OK"
  },
  "TH_THA": {
    "optional": "(ไม่บังคับ)",
    "cancel": "ยกเลิก",
    "apply": "นำไปใช้",
    "invalidDOB": "กรุณากรอกวันเกิดที่ถูกต้อง",
    "futureDOB": "วันเกิดต้องเป็นวันที่ผ่านมาแล้ว",
    "next": "ถัดไป",
    "genderMaritalNote": "เรารวบรวมข้อมูลเพศและสถานภาพสมรสเพื่อเข้าใจคุณมากขึ้น",
    "learnMore": "ดูข้อมูลเพิ่มเติม",
    "learnMoreTitle": "ทำไมเราจึงเก็บข้อมูลเกี่ยวกับคุณ?",
    "learnMoreIntro": "ข้อมูลนี้ช่วยให้เรา:",
    "learnMorePoint1Title": "ปรับแต่งคำแนะนำและการสนับสนุนของเรา",
    "learnMorePoint1Desc": "รวมถึงคำแนะนำหลักสูตร บริการนักศึกษา และตัวเลือกที่พัก",
    "learnMorePoint2Title": "ช่วยเหลือเรื่องข้อกำหนดวีซ่าและการเดินทาง",
    "learnMorePoint2Desc": "เนื่องจากบางประเทศที่เป็นจุดหมายการศึกษามีกฎการตรวจคนเข้าเมืองเฉพาะสำหรับนักศึกษาที่แต่งงานแล้วหรือคู่สมรสที่ติดตาม การให้ข้อมูลสถานภาพสมรสช่วยให้เราให้คำแนะนำที่ถูกต้องและรับรองกระบวนการที่ราบรื่นยิ่งขึ้น",
    "learnMorePoint3Title": "มีส่วนร่วมในการวางแผนและรายงานอย่างครอบคลุม",
    "learnMorePoint3Desc": "ช่วยให้เราปรับปรุงการให้บริการและตอบสนองความคาดหวังด้านความหลากหลาย ความเท่าเทียม และข้อกำหนดด้านกฎระเบียบ การให้ข้อมูลเพศและสถานภาพสมรสเป็นทางเลือก และคุณสามารถเลือก \"ไม่ต้องการระบุ\" ได้ ข้อมูลส่วนบุคคลของคุณจะได้รับการจัดการอย่างปลอดภัยตามกฎหมายคุ้มครองข้อมูลที่เกี่ยวข้องและนโยบายความเป็นส่วนตัวของสถาบัน",
    "ok": "ตกลง"
  },
  "KR_KOR": {
    "optional": "(선택 사항)",
    "cancel": "취소",
    "apply": "적용",
    "invalidDOB": "유효한 생년월일을 입력하세요",
    "futureDOB": "생년월일은 과거 날짜여야 합니다",
    "next": "다음",
    "genderMaritalNote": "성별 및 결혼 여부 정보는 더 나은 지원을 위해 수집됩니다",
    "learnMore": "자세히 보기",
    "learnMoreTitle": "왜 귀하의 정보를 수집하나요?",
    "learnMoreIntro": "이 정보는 다음을 위해 도움이 됩니다:",
    "learnMorePoint1Title": "맞춤형 안내 및 지원 제공",
    "learnMorePoint1Desc": "과정 추천, 학생 서비스 및 숙소 옵션을 포함합니다.",
    "learnMorePoint2Title": "비자 및 여행 요건 지원",
    "learnMorePoint2Desc": "일부 유학 국가에는 기혼 학생이나 동반 배우자에 대한 특정 이민 규정이 있습니다. 혼인 상태를 제공하면 정확한 조언과 원활한 처리를 보장할 수 있습니다.",
    "learnMorePoint3Title": "포용적 계획 및 보고에 기여",
    "learnMorePoint3Desc": "서비스 제공을 개선하고 다양성, 형평성 및 규제 기대를 충족하는 데 도움이 됩니다. 성별 및 혼인 상태 정보 제공은 선택 사항이며, 원하시면 \"밝히고 싶지 않음\"을 선택할 수 있습니다. 귀하의 개인 데이터는 관련 데이터 보호법 및 기관 개인정보 보호 정책에 따라 안전하게 처리됩니다.",
    "ok": "확인"
  },
  "TW_CHI": {
    "optional": "(選填)",
    "cancel": "取消",
    "apply": "套用",
    "invalidDOB": "請輸入有效出生日期",
    "futureDOB": "出生日期需為過去日期",
    "next": "下一步",
    "genderMaritalNote": "我們蒐集性別與婚姻狀況資訊，以更了解你的背景並支持你的留學之路",
    "learnMore": "了解更多",
    "learnMoreTitle": "為什麼我們要收集您的資訊？",
    "learnMoreIntro": "這些資訊幫助我們：",
    "learnMorePoint1Title": "量身定制我們的指導和支持",
    "learnMorePoint1Desc": "包括課程推薦、學生服務和住宿選擇。",
    "learnMorePoint2Title": "協助簽證和旅行要求",
    "learnMorePoint2Desc": "某些留學目的地對已婚學生或陪同配偶有特定的移民規定。提供您的婚姻狀況使我們能夠提供準確的建議，並確保您所選目的地的處理更加順暢。",
    "learnMorePoint3Title": "促進包容性規劃和報告",
    "learnMorePoint3Desc": "幫助我們改善服務並滿足多元化、公平性和法規要求。提供性別和婚姻狀況資訊為選填項目，您可以選擇「不方便透露」。您的個人資料將根據適用的資料保護法和我們的機構隱私政策安全處理。",
    "ok": "確定"
  },
  "HK_CHI": {
    "optional": "(選填)",
    "cancel": "取消",
    "apply": "套用",
    "invalidDOB": "請輸入有效出生日期",
    "futureDOB": "出生日期必須為過去日期",
    "next": "下一步",
    "genderMaritalNote": "我們收集性別及婚姻狀況資料，以更好了解您的背景並支持您的留學旅程",
    "learnMore": "了解更多",
    "learnMoreTitle": "為什麼我們要收集您的資料？",
    "learnMoreIntro": "這些資料幫助我們：",
    "learnMorePoint1Title": "度身訂造我們的指導和支援",
    "learnMorePoint1Desc": "包括課程推薦、學生服務和住宿選擇。",
    "learnMorePoint2Title": "協助簽證和旅行要求",
    "learnMorePoint2Desc": "某些升學目的地對已婚學生或陪同配偶有特定的入境規定。提供您的婚姻狀況使我們能夠提供準確的建議，並確保您所選目的地的處理更加順暢。",
    "learnMorePoint3Title": "促進包容性規劃和報告",
    "learnMorePoint3Desc": "幫助我們改善服務並滿足多元化、公平性和法規要求。提供性別和婚姻狀況資料為選填項目，您可以選擇「不願透露」。您的個人資料將根據適用的資料保護法和我們的機構私隱政策安全處理。",
    "ok": "確定"
  },
  "HK_ZK": {
    "optional": "(可选)",
    "cancel": "取消",
    "apply": "应用",
    "invalidDOB": "请输入有效出生日期",
    "futureDOB": "出生日期必须为过去日期",
    "next": "下一步",
    "genderMaritalNote": "我们收集性别和婚姻状况信息，以更好了解您的背景并支持您的留学之旅",
    "learnMore": "了解更多",
    "learnMoreTitle": "为什么我们要收集您的信息？",
    "learnMoreIntro": "这些信息帮助我们：",
    "learnMorePoint1Title": "量身定制我们的指导和支持",
    "learnMorePoint1Desc": "包括课程推荐、学生服务和住宿选择。",
    "learnMorePoint2Title": "协助签证和旅行要求",
    "learnMorePoint2Desc": "某些留学目的地对已婚学生或陪同配偶有特定的移民规定。提供您的婚姻状况使我们能够提供准确的建议，并确保您所选目的地的处理更加顺畅。",
    "learnMorePoint3Title": "促进包容性规划和报告",
    "learnMorePoint3Desc": "帮助我们改善服务并满足多元化、公平性和法规要求。提供性别和婚姻状况信息为可选项，您可以选择「不愿透露」。您的个人数据将根据适用的数据保护法和我们的机构隐私政策安全处理。",
    "ok": "确定"
  }
}
